export default {
  apiKey: 'AIzaSyB06T1CUnEsqt_RYNcAq0vVWrk8-My6GTs',
  authDomain: 'memi-site.firebaseapp.com',
  databaseURL: 'https://memi-site.firebaseio.com',
  projectId: 'memi-site',
  storageBucket: 'memi-site.appspot.com',
  messagingSenderId: '295499872044',
  appId: '1:295499872044:web:61185feb9effaccbe4de89',
  measurementId: 'G-Z55V690FDW'
}
